<template>
  <div class="open-native-wrap" v-if="show">
    <div class="close" @click="show = false"></div>
    <div class="logo"></div>
    <div class="des">更多精彩打开APP查看</div>
    <div class="open-btn">
      <WXLaunchBtn
        @error="handleWxLunchBtnError"
        @wxClick="handleWxClick"
        :schema="schema"
      >
        <template slot="default">
          <div class="open-btn-in" id="openBtn" @click="callNativeAmap">打开</div>
        </template>
      </WXLaunchBtn>
    </div>
  </div>
</template>
<script>
import { webviewInfo } from '@ali/amap-lib';
import getShareLogParams from '@ali/amap-call-native/getShareLogParams';
import WXLaunchBtn from './WXLaunchBtn.vue';

export default {
  props: {
    // schema跳转地址
    schema: {
      type: String,
      default: '',
    },
    // 页面类型
    pageType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: true,
      share_channelSpm: 'amap.2019_push_template.call.call_amap',
    };
  },
  components: {
    WXLaunchBtn,
  },
  created() {
    if (!webviewInfo.isInAmap()) {
      const params = getShareLogParams({
        page_type: this.pageType
      });
      console.log(params, '曝光=====埋点全链路参数');
      // eslint-disable-next-line no-undef
      window?.AmapTracker?.recordEXP('call.call_amap', {
        params: {
          ...params,
          share_channelSpm: this.share_channelSpm
        },
      });
    }
  },
  methods: {
    callNativeAmap() {
      this.$emit('goAmap');
    },
    // open-tag点击需要埋点
    handleWxClick() {
      this.$emit('openAmapLog', 'opentag');
    },
    // 如果wx launch出现错误的话，就使用原来的逻辑
    handleWxLunchBtnError() {
      this.$emit('goAmap');
    }
  }
};
</script>

<style lang="scss">
@import "../css/index";
@import "../../../common/css/common-mixin";
.open-native-wrap {
    position: relative;
    width: 100%;
    height: rpx(100);
    display: flex;
    justify-content: right;
    align-items: center;
    border-bottom: 1px solid #ddd;
    box-shadow: 0 -1px 1px 3px rgba(0, 0, 0, 0.1);
    .close,
    .logo,
    .des {
      position: absolute;
      top: 50%;
      height: rpx(50);
      margin-top: rpx(-25);
    }
    .close {
      left: rpx(10);
      width: rpx(40);
      height: rpx(40);
      margin-top: rpx(-20);
      background: url("../../../assets/img/close-btn.png") no-repeat center;
      background-size: contain;
    }
    .logo {
      left: rpx(60);
      width: rpx(158);
      height: rpx(52);
      margin-top: rpx(-26);
      background: url("../../../assets/img/amap-logo.png") no-repeat center;
      background-size: contain;
    }
    .des {
      left: rpx(248);
      line-height: rpx(50);
      color: #797979;
      font-size: rpx(24);
    }
    .open-btn {
      position: absolute;
      right: rpx(32);
      width: rpx(112);
      height: rpx(60);
      line-height: rpx(60);
      .open-btn-in{
        width: rpx(112);
        height: rpx(60);
        line-height: rpx(60);
        border-radius: rpx(56);
        background-color: #4287ff;
        color: #fff;
        text-align: center;
        font-size: rpx(24);
      }
    }
  }
</style>
